import './Header.css';
import { Button } from 'react-bootstrap';
import GithubIcon from "./assets/github-mark.png";

export default function Header() {
  return (
    <header className='Header'>
        <h1>OMSCS Course Planner</h1>
        <div className="actions">
          <Button 
            href="https://eatstash.com/" 
            target="_blank" 
            rel="noopener"
            className="eatstash-button"
          >
            <span className="eatstash-desktop-text">Try my recipe app, EatStash!</span>
            <span className="eatstash-mobile-text">Try my recipe app!</span>
          </Button>
          <a
            href="https://www.buymeacoffee.com/logictonic"
            target="_blank"
            rel="noopener noreferrer"
            className="coffee-button"
            aria-label="Buy me a coffee"
          >
            <img 
              src="https://cdn.buymeacoffee.com/buttons/v2/default-blue.png" 
              alt="Buy Me A Coffee" 
            />
          </a>
          <a
            href="https://github.com/logic-tonic/omscs-course-planner"
            target="_blank"
            rel="noreferrer"
            aria-label="View source on GitHub"
          >
            <img className="github" src={ GithubIcon } alt="Github"/>
          </a>
        </div>
    </header>
  );
}
